import React, { useState } from 'react';

type FloatingNewNoteButtonProps = {
  visible: boolean;
  onClick: () => void;
  label?: string;
  alwaysExpanded?: boolean;
  rightPx?: number;
  bottomCss?: string;
  backgroundColor?: string;
};

const FloatingNewNoteButton: React.FC<FloatingNewNoteButtonProps> = ({
  visible,
  onClick,
  label = 'New Note',
  alwaysExpanded = false,
  rightPx = 16,
  bottomCss = '2rem',
  backgroundColor,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isFocused, setIsFocused] = useState(false);

  if (!visible) return null;

  const isExpanded = alwaysExpanded || isHovered || isFocused;

  return (
    <div
      style={{
        position: 'fixed',
        right: rightPx,
        bottom: bottomCss,
        zIndex: 1000,
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <button
        type="button"
        aria-label={label}
        title={label}
        style={{
          backgroundColor: backgroundColor || '#000000',
          color: '#ffffff',
          border: 'none',
          borderRadius: isExpanded ? '60px' : '999px',
          width: isExpanded ? '117px' : '40px',
          height: '40px',
          fontSize: isExpanded ? '14px' : '18px',
          fontWeight: isExpanded ? 500 : 600,
          cursor: 'pointer',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: isExpanded ? '10px' : 0,
          padding: isExpanded ? '8px 10px' : 0,
          transition: 'width 180ms ease, border-radius 180ms ease, padding 180ms ease, font-size 180ms ease',
        }}
        onClick={onClick}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
      >
        <span style={{ fontSize: isExpanded ? '18px' : undefined, fontWeight: 600 }}>+</span>
        {isExpanded && <span>{label}</span>}
      </button>
    </div>
  );
};

export default FloatingNewNoteButton;
